import {cUtil}                    from './util';
import {cProductInfo}             from './../pages/single-product/product-info/product-info';
import {cRelatedProductsCarousel} from '../pages/single-product/related-products-carousel/main';
import {cRelatedProducts}         from '../pages/single-product/related-products/related-products';
import {cRelatedProductsTags}     from '../pages/single-product/related-products/tags/related-products-tags';
import {cSearch}                  from '../pages/shop/search/search';
import {cOrderListOverview}       from '../pages/order-list-overview/order-list-overview';
import {cOrderList}               from '../pages/order-list/order-list';
import {cShop}                    from '../pages/shop/shop';
import {cOrderAgain}              from '../pages/order-details/order-again';
import {cAdminUser}               from '../pages/admin-user/admin-user';
import {cAdminCustomerSelect}     from '../pages/admin-user/customer/admin-customer-select';
import {cAdminUserImage}          from '../pages/admin-user/image/main';
import {cAdminUsers}              from '../pages/admin-users/admin-users';
import {cAdminCustomers}          from '../pages/admin-customers/admin-customers';
import {cAdminDeliveryItems}      from '../pages/admin-delivery-items/admin-delivery-items';
import {cAdminReconciliation}     from '../pages/admin-reconciliation/admin-reconciliation';
import {cAdminOrderRefund}        from '../pages/admin-order/admin-order-refund';
import {cCart}                    from '../pages/cart/cart';
import {cCheckout}                from '../pages/checkout/checkout';
import {cAdminImport}             from '../pages/admin-import/adminImport';
import {cAdminAccountAddress}     from '../pages/account-address/account-address';
import {cContact}                 from '../pages/contact/contact';
import {cAccount}                 from '../pages/account-details/account';
import {cAccountStats}            from '../pages/account-downloads/stats/account-stats';
import {cAdminAds}                from '../pages/admin-ads/admin-ads';
import {cAdCarousel}              from '../components/ad-carousel/ad-carousel';
import {cBrowserVersion}          from '../components/browser-version/browser-version';
import {cFooter}                  from '../components/footer/main';
import {cHeader}                  from '../components/header/header';
import {cSystemMessage}           from '../components/system-message/system-message';
import {cSingleProduct}           from '../pages/single-product/single-product/single-product';
import {cAccountLogin}            from '../pages/account-login/account-login';

try {
  cUtil.gaSendFromStorage();

  if (!cBrowserVersion.browserSuppored()) {
    new cBrowserVersion();
  }
  if (cUtil.isIOS()) {
    // Disable iPhone zooming in on input elements with fontsize < 16px
    const meta = document.head.querySelector('meta[name="viewport"]') as HTMLMetaElement;
    meta.content = "width=device-width, initial-scale=1, maximum-scale=1";
  }

  if (cUtil.checkPage('#customer_login')) {
    new cAccountLogin();
  }
  if (cUtil.checkPage('#woocommerce-order-items')) {
    new cAdminOrderRefund();
  }
  if (cUtil.checkPage('.c-account-customer-address')) {
    new cAdminAccountAddress();
  }
  if (cUtil.checkPage('.c-ad-carousel')) {
    new cAdCarousel();
  }
  if (cUtil.checkPage('.c-admin-customers')) {
    new cAdminCustomers();
  }
  if (cUtil.checkPage('.c-admin-user-image')) {
    new cAdminUserImage();
  }
  if (cUtil.checkPage('.c-cart')) {
    new cCart();
  } 
  if (cUtil.checkPage('.c-checkout-summary')) {
    new cCheckout();
  } 
  if (cUtil.checkPage('.c-contact')) {
    new cContact();
  }
  if (cUtil.checkPage('.c-data-import')) {
    new cAdminImport();
  }
  if (cUtil.checkPage('.c-delivery-items')) {
    new cAdminDeliveryItems();
  }
  if (cUtil.checkPage('.c-reconciliation')) {
    new cAdminReconciliation();
  }
  if (cUtil.checkPage('.c-delete-account')) {
    new cAccount();
  }
  if (cUtil.checkPage('.c-order-list') && cOrderList.dataExists()) {
    new cOrderList();
  }
  if (cUtil.checkPage('.c-order-list-overview')) {
    new cOrderListOverview();
  }
  if (cUtil.checkPage('.c-product-info-info-fields')) {
    new cRelatedProducts();
    new cProductInfo();
  }
  if (cUtil.checkPage('.c-tags')) {
    new cRelatedProductsTags();
  }
  if (cUtil.checkPage('.c-related-products-carousel')) {
    new cRelatedProductsCarousel();
  }
  if (cUtil.checkPage('.c-search')) {
    new cSearch();
  }
  if (cUtil.checkPage('.c-shop')) {
    new cShop();
  }
  if (cUtil.checkPage('.c-single-product')) {
    new cSingleProduct();
  } 
  if (cUtil.checkPage('.c-stats-container')) {
    new cAccountStats();
  }
  if (cUtil.checkPage('.order-again .button')) {
    new cOrderAgain();
  }
  if (!cUtil.checkPage('.wp-admin')) {
    if (wp?.customize?.control === undefined) {
      // if is necessary because of negation in if above.
      new cHeader();
      new cFooter();
      new cSystemMessage();
      // new cCookieBanner();
    }
  }
  if (cUtil.checkPage('.wp-admin.profile-php')) {
    new cAdminCustomerSelect();
  }
  if (cUtil.checkPage('.wp-admin.toplevel_page_werbung')) {
    new cAdminAds();
  }
  if (cUtil.checkPage('.wp-admin.user-edit-php')) {
    new cAdminCustomerSelect();
  }
  if (cUtil.checkPage('.wp-admin.user-new-php')) {
    new cAdminCustomerSelect();
    new cAdminUser();
  }
  if (cUtil.checkPage('.wp-admin.users-php')) {
    new cAdminUsers();
  }

  document.addEventListener('contextmenu', event => {
    // event.preventDefault(); // todo-deploy
  });
}
catch(e) {
  const formData = new FormData();

  if (e instanceof Error) {

    console.error(e.stack);
    cUtil.logAtEnd(e.message);
    console.error(e.message);
    formData.append('message', e.message);
    formData.append('stack'  , e.stack ?? '');
    formData.append('agent'  , navigator.userAgent);
  }
  else if (typeof e === 'string') {
    cUtil.logAtEnd(e);
    console.error(e);
    formData.append('message', e);
    formData.append('agent'  , navigator.userAgent);
  }
  else {
    cUtil.logAtEnd('unknown error');
    console.error('unknown error')
    formData.append('message', 'unknown error');
    formData.append('agent'  , navigator.userAgent);
  }
  fetch('/c-errors', {
    method: 'POST',
    body: formData,
  });
};
